<template>
    <div>
        <h1>Credentialer Assignment Search</h1>
        <div class="card">
            <div class="card-body">
                <h2 class="green-header">Search by Assigned Credentialler: </h2>
                <b-row>
                    <b-col>
                        <form-summary :validator="$v.screen" ref="nameErrorContainer" id="nameErrorContainer"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="4" md="4" id="lastNameDiv">
                        <BaseTextInput v-model="search.lastName"
                                       :v="$v.search.lastName"
                                       label="Last Name"
                                       slug="lastName"
                                       setId="lastName"/>
                    </b-col>
                    <b-col cols="4" md="4" id="firstNameDiv">
                        <BaseTextInput v-model="search.firstName"
                                       :v="$v.search.firstName"
                                       label="First Name"
                                       slug="firstName"
                                       setId="firstName"/>
                    </b-col>
                    <b-col cols="4" md="4" id="usernameDiv">
                        <BaseTextInput v-model="search.username"
                                       :v="$v.search.username"
                                       label="AD Name"
                                       slug="username"
                                       setId="username"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="1">
                        <b-button type="button" variant="primary" @click="searchAssigned">Search</b-button>
                    </b-col>
                    <b-col cols="1">
                        <b-button type="button" variant="secondary" @click="clearSearch">Clear</b-button>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-table hover small show-empty class="sr-caption" style="width: 100%"
                             aria-live="polite"
                             responsive="true"
                             :fields="fields"
                             :items="results"
                             :busy="isLoading"
                             :sort-by.sync="sortBy"
                             :sort-desc.sync="sortDesc"
                             caption="Search table.  To sort the data in this table by a specific column,
                                                        go to the appropriate column header cell and use enter to sort the data ascending.
                                                        Use enter again to sort descending.">
                        <template v-slot:no-data>
                            No Assigned Applications or Change Requests Found.
                        </template>
                        <template v-slot:cell(submittedDate)="row">
                            {{formatDateTime(row.item.submittedDate)}}
                        </template>
                        <template v-slot:cell(assignedDate)="row">
                          {{formatDateTime(row.item.assignedDate)}}
                        </template>
                        <template v-slot:cell(actions)="row">
                            <b-button size="sm" @click="launchAssign(row.item)"
                                      variant="primary"
                                      class="mr-1">Re-Assign</b-button>
                        </template>
                    </b-table>
                </b-row>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from "axios"
    import axiosRetry from 'axios-retry'
    import {required} from 'vuelidate/lib/validators'
    import {toastService} from "@/mixins/toastService";
    import BaseTextInput from "@/components/templates/input/BaseTextInput";
    import moment from 'moment';

    axiosRetry(axios, {
        retries: 3,
        retryDelay: axiosRetry.exponentialDelay
    })

    export default {
        components:{
            BaseTextInput
        },
        data() {
            return {
                sortBy: 'startDate',
                sortDesc: true,
                results: [],
                search: {
                    firstName: '',
                    lastName: '',
                    username: '',
                },
                submitted: false,
                isLoading: false,
                fields: [
                    {key: 'fullName', label: 'Full Name', sortable:true},
                    {key: 'ssn', label: 'SSN', sortable:true},
                    {key: 'certificateNumber', label: 'Certificate Number', sortable: true},
                    {key: 'status', label: 'Status', sortable:true},
                    {key: 'submittedDate', label:'Submitted Date', sortable:true},
                    {key: 'type.description', label:'Request Type', sortable:true},
                    {key: 'assignedName', label: 'Credentialer Assigned', sortable:true},
                    {key: 'assignedDate', label: 'Credentialer Assigned Date', sortable: true},
                    {key: 'actions', label:'Actions', sortable:false}
                ],
            }
        },
        mixins: [
            toastService
        ],
        methods: {
            searchAssigned() {
                this.$v.$touch()
                    if(this.$v.$invalid){
                        toastService.showRootToast("Error", "Missing required fields.", "danger", this.$root)
                        return
                    }
                this.isLoading = true
                this.submitted = true
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/assign-search`, this.search)
                    .then(response => {
                        this.results = response.data
                        this.isLoading = false
                    })
            },
            clearSearch() {
                this.results = []
                this.search = {
                    firstName: '',
                    lastName: '',
                    username: '',
                }
                this.$v.$reset()
                this.submitted = false
            },
            formatDateTime(unformattedDate){
                let formattedDate = moment(unformattedDate);
                if(!formattedDate.isValid()) return '';
                return formattedDate.format("MM/DD/YYYY hh:mmA")
            },
            launchAssign(item){
                this.$router.push({path: `/credentialer-assign/${item.id}/${item.type.code}`});
            },
        },
        validations() {
            return {
                search: {
                    firstName: {
                        required: false
                        },
                    lastName: {
                        required: false
                    },
                    username: {
                        required: false
                    }
                }
            }
        },
        created() {
            document.title = "Credentialer Search - NAR"
        },
    }
</script>
